import styled from 'styled-components';

export default styled.section`
  .items { 
    display: flex;
    gap: var(--size-lg);

    .item {
      padding: 28px 30px;
      flex: 1;
      background: #FAFAFA;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-width: 145px;
      gap: 18px;
      border-radius: 4px;

      &:last-of-type {
        border-right: 0px;
      }

      .cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .item-cont {
        display: flex;
        justify-content: center;
        gap: 12px;

        &.icon {
          i {
            font-size: 30px;
            color: var(--color-primary-70);
          }
        }

        &.item-header {
          h2 {
            font-size: 14px;
            font-weight: 500; 
            margin-bottom: 0px;
            text-align: center;
          }
        }

        &.value {
          h2 {
            font-size: 20px;
            font-weight: 600; 
            margin-bottom: 0px;
            text-align: center;
          }
        }
      }
    }
  }
`;

export const EmptyState = styled.div`
  border: 1px solid #D1D1D1;
  padding: 30px;
  flex: 1;
  display: flex;
  gap: 14px;

  label {
    margin-bottom: 0px;
    color: #D1D1D1;
    font-weight: 600;
    font-size: 20px;

    strong {
      font-weight: 600;
    }
  }

  svg {
    fill: #FEA14B;
    font-size: 21px;
    margin-top: 4px;
  }

  p {
    margin-bottom: 0px;
  }
`;

export const PopOver = styled.div`
  max-width: 200px;
  padding: 14px 4px;

  h4 {
    font-weight: 600;
    font-size: 14px;
    color: #001529;
  }

  p {
    margin-bottom: 0px;
  }
`;
